import axios from 'axios';

const deleteNotice = (uuid) =>
{
    let api =`${process.env.REACT_APP_LMS_API}api/NoticeBoard/deleteNotice?/id={uuid}`
    const headers = { };  
    return axios.post(api, {headers: headers})   
}

const saveNotice = (notice, option) =>
{
       let api =`${process.env.REACT_APP_LMS_API}api/NoticeBoard/saveNotice`
        const headers = { 'Content-Type': 'multipart/form-data' };     
        //let api =`https://localhost:5001/api/NoticeBoard/saveNotice`
       //const headers = {};   
       const formData = new FormData();
        Object.entries(notice).map(([key, value]) => {
           if (key == "files")
           {
              value.forEach((file) => {
                formData.append('files', file); // 'files' must match the backend parameter name
              });
           }
        //    else if (key == "sectionlist")
        //     {
        //         var seclist = value.toString()
        //         formData.append(key, seclist);
        //     } 
            else
            {
                  formData.append(key, value);
            }
       
        })
    return axios.post(api,formData,option,{headers: headers})    
}

export default {
    deleteNotice,
    saveNotice
  };